import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_LOGO_URL, SITE_NAME, SITE_ORIGIN } from '../seo/site';

/** Organization + WebSite graph; safe on every route. */
const GlobalJsonLd: React.FC = () => {
  const json = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': `${SITE_ORIGIN}/#organization`,
        name: SITE_NAME,
        url: SITE_ORIGIN,
        logo: {
          '@type': 'ImageObject',
          url: SITE_LOGO_URL,
          width: 512,
          height: 512,
        },
      },
      {
        '@type': 'WebSite',
        '@id': `${SITE_ORIGIN}/#website`,
        url: SITE_ORIGIN,
        name: SITE_NAME,
        publisher: { '@id': `${SITE_ORIGIN}/#organization` },
        inLanguage: ['en', 'pt-BR'],
      },
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(json)}</script>
    </Helmet>
  );
};

export default GlobalJsonLd;
